<div>
    <div class="position-relative overflow-hidden p-3 p-md-5 m-md-3 text-center bg-light" *ngIf="friends && friends.length == 0">
        <div class="col-md-5 p-lg-5 mx-auto my-5">
            <h1 class="display-4 font-weight-normal">Get a match</h1>
            <p class="lead font-weight-normal">And start chatting with people across the globe sharing similar problems</p>
            <button class="btn btn-outline-secondary" (click)="findFriend()">Start</button>
        </div>
    </div>

    <div class="container">
        <div class="row border-bottom mb-3" *ngFor=" let friend of friends ">
            <div class="col-sm-2 ">
                <div class="avatar-container text-center my-3">
                    <img src="https://bootdey.com/img/Content/avatar/avatar4.png " alt="user " class="profile-photo-lg ">
                    <h5 class="profile-link mt-4 ">{{friend.name}}</h5>
                </div>
            </div>
            <div class="col-md-5 my-auto text-center p-1">
                <div class="container">
                    <mdb-badge class="dbadge grey lighten-1 m-1 " pill="true " *ngFor="let d of getTranslatedDisorders(friend) ">{{d}}</mdb-badge>
                </div>
            </div>
            <div class="col-sm-2 my-auto text-center">
                <button class="btn btn-primary chat" (click)="chatWith(friend) "><mdb-icon far icon="paper-plane" class="mr"></mdb-icon></button>
            </div>
        </div>
    </div>

    <div class="text-center" *ngIf="friends.length > 0">
        <button mdbBtn size="m" mdbWavesEffect type="button " class="btn btn-primary btn-lg " (click)="findFriend() ">Find new friend</button>
    </div>
</div>